export const SET_SORT_OPTION = 'sort/SET_SORT_OPTION';
export const SET_SORT_TYPE = 'sort/SET_SORT_TYPE';